export default {

  // Пʼять місць нижньої панелі (картка TabBar). Підписи — одне слово:
  // на 320 частка вкладки має 58 px.
  "tab.time": "Час",
  "tab.records": "Записи",
  "tab.write": "Писати",
  "tab.people": "Люди",
  "tab.more": "Ще",
  "nav.tabs": "Розділи",
  // Бічна панель ноутбука (картка DesktopShell). Назва продукту — власна.
  "about.brand": "Береста",
  "sidebar.writeTip": "Писати · {key}",
  "sidebar.keyN": "N",
  "nav.scale": "Масштаб",
  "nav.search": "Пошук",

  "common.cancel": "Скасувати",
  "common.done": "Готово",
  "common.back": "Назад",

  // Вибір дати B4: швидкі варіанти й стрілки сітки.
  "date.tomorrow": "Завтра",
  "date.afterTomorrow": "Післязавтра",
  "date.nextWeek": "Наступний тиждень",
  "date.nextMonth": "Наступний місяць",
  "date.nextYear": "Наступний рік",
  "date.years": "{from}–{to}",
  "date.prev": "Раніше",
  "date.next": "Пізніше",

  "scale.year": "Рік",
  "scale.month": "Місяць",
  "scale.week": "Тиждень",
  "scale.day": "День",

  // Шапка «Часу»: підпис над датою й сусідні періоди.
  "time.kick.year": "Рік",
  "time.kick.week": "Тиждень {n}",
  "time.week.range": "{from}–{to} {month}",
  "time.week.cross": "{from} {fromMonth} – {to} {toMonth}",
  "time.tomorrow": "Завтра",
  "time.yesterday": "Учора",
  "time.next.day": "{day} {month}",
  "time.next.week": "Тиж. {n}",
  "time.prev.day": "Попередній день — {label}",
  "time.prev.week": "Попередній тиждень — {label}",
  "time.prev.month": "Попередній місяць — {label}",
  "time.prev.year": "Попередній рік — {label}",
  "time.next.day.aria": "Наступний день — {label}",
  "time.next.week.aria": "Наступний тиждень — {label}",
  "time.next.month.aria": "Наступний місяць — {label}",
  "time.next.year.aria": "Наступний рік — {label}",

  "monthShort.1": "січ.",
  "monthShort.2": "лют.",
  "monthShort.3": "бер.",
  "monthShort.4": "квіт.",
  "monthShort.5": "трав.",
  "monthShort.6": "черв.",
  "monthShort.7": "лип.",
  "monthShort.8": "серп.",
  "monthShort.9": "вер.",
  "monthShort.10": "жовт.",
  "monthShort.11": "лист.",
  "monthShort.12": "груд.",
  "shell.tagline": "Щоденник і планер, який працює без мережі",
  "shell.loading": "Хвилинку…",
  "shell.offline": "Дані лишаються на цьому пристрої, доки ви не ввімкнете синхронізацію.",
  "shell.address": "Адреса сторінки — це горизонт: рік, місяць, тиждень або день.",

  "nav.today": "Сьогодні",
  // Позначка, а не кнопка: маленькою літерою й у чипі, як у макеті.
  // Кнопка веде на сьогодні, позначка каже, що ти вже тут.
  "nav.todayMark": "сьогодні",
  "nav.trail": "Масштаб часу",
  "nav.hop": "Сусідні сторінки",
  // Називає, куди саме повертає: «Назад» без місця змушує здогадуватись,
  // а повертає воно не на сьогодні, а туди, де людина була.
  "nav.back": "← {where}",
  // «Захопити» — слово з документації (модуль C, «швидке захоплення»), а не
  // з мови людини: стороння відповідала «захопити кого?». Кнопка називає
  // дію, яку робить.
  "nav.capture": "Записати",
  // Четвертий пункт нижньої панелі телефона. Слово коротке навмисно:
  // у панелі на 390 px кожна частка має 72 px, і довше туди не влазить.
  "nav.more": "Ще",

  // Ключ горизонту — не підпис: «2026-W35» людині нічого не каже.
  "horizon.year": "{year} рік",
  "horizon.month": "{month} {year}",
  "horizon.week": "{n}-й тиждень {year}",
  "horizon.day": "{day} {month} {year}",
  // Заголовок сторінки дня — **без року**, і це не скорочення заради краси.
  // «14 вересня 2026» у `largeTitle` не вміщається в 390 px і переноситься
  // на два рядки, зʼїдаючи третину першого екрана. Рік при цьому нікуди не
  // дівається: він стоїть першою пігулкою ланцюга просто над заголовком,
  // тобто повторювався б двічі поспіль. Так і в макеті.
  "horizon.dayHead": "{day} {month}",
  "trail.week": "Тиж {n}",
  "trail.day": "{day} {month}",

  // Два відмінки, і це не надмірність. Родовий іде в дату («29 грудня»),
  // називний — коли місяць названий сам («Грудень 2026»). Досі підпис місяця
  // збирався з родового й читався як «грудня 2026».
  "monthName.1": "Січень",
  "monthName.2": "Лютий",
  "monthName.3": "Березень",
  "monthName.4": "Квітень",
  "monthName.5": "Травень",
  "monthName.6": "Червень",
  "monthName.7": "Липень",
  "monthName.8": "Серпень",
  "monthName.9": "Вересень",
  "monthName.10": "Жовтень",
  "monthName.11": "Листопад",
  "monthName.12": "Грудень",

  "month.1": "січня",
  "month.2": "лютого",
  "month.3": "березня",
  "month.4": "квітня",
  "month.5": "травня",
  "month.6": "червня",
  "month.7": "липня",
  "month.8": "серпня",
  "month.9": "вересня",
  "month.10": "жовтня",
  "month.11": "листопада",
  "month.12": "грудня",

  "day.plan": "План дня",
  "day.entries": "Записи дня",
  "day.inbox": "В інбоксі",
  "day.hopDate": "{weekday}, {date}",
  // Заголовки блоків сусідніх днів далеко від сьогодні: «Учора» й «Завтра»
  // там були б неправдою, а дата вже стоїть другим рядком.
  "day.hopPrev": "Попередній день",
  "day.hopNext": "Наступний день",
  "day.emptyTitle": "Тут поки нічого",
  "day.emptyText": "Можна написати, а можна просто закрити застосунок.",
  // Факт, а не докір: ні «ви пропустили», ні серії.
  "day.lastEntry": "Останній запис був {date}.",
  "entry.meta": "{time} · {kind}",
  "entry.kind.journal": "запис",
  "entry.kind.note": "нотатка",
  "entry.kind.inbox": "інбокс",
  "day.prose": "Запис",
  "day.addIntent": "Додати до плану",
  "day.addPlaceholder": "Що зробити цього дня",
  "day.loading": "Читаю запис…",
  "day.editorLoading": "Готую редактор…",
  "day.saved": "Збережено",
  "day.mood": "Настрій",
  // Позиція лишається в підписі для читача екрана: «третій з пʼяти» каже
  // про шкалу те, чого не скаже саме слово.
  "day.moodPick": "{name} — настрій {n} з 5",
  // Кружок без слова читається лише кольором і місцем у ряду, а це
  // не читається взагалі: третій — це «нормально» чи «так собі»?
  "day.mood.1": "важко",
  "day.mood.2": "так собі",
  "day.mood.3": "звичайно",
  "day.mood.4": "добре",
  "day.mood.5": "чудово",

  "plan.count": "{done} з {total}",
  "plan.add": "Додати пункт",
  "plan.rolledShort": "×{n}",
  "plan.empty": "Плану на цей день ще немає.",
  // Показується, доки на цьому пристрої не написано жодного наміру.
  // Порожня картка не пояснює нічого: людина, яка щойно завела щоденник,
  // бачить порожнечу й не знає, що вона тут робить.
  "plan.firstHint":
    "Напишіть унизу, що хочете зробити цього дня, — наприклад, «зателефонувати в поліклініку». Те, на що дня не стане, ввечері переносять на завтра кнопкою «Перенести».",
  "plan.markDone": "Позначити виконаним",
  "plan.markUndone": "Зняти позначку",
  "plan.rolled": "перенесено",
  // Скільки разів справу відкладали. Папір цього не показує — переписана
  // втретє справа виглядає на ньому як щойно записана.
  "plan.rolledTimes": "перенесено ×{n}",
  // Три форми множини — саме те, заради чого шар локалізації на ICU.
  "plan.more": "{n, plural, one {ще # справа} few {ще # справи} many {ще # справ} other {ще # справи}}",
  // Кнопка коротка, підпис для читача екрана — повний: у заголовку блоку
  // тижня «Перенести невиконане» не вміщається поруч із «Цілі тижня».
  "plan.roll": "Перенести",
  "plan.rollAll": "Перенести невиконане",

  "weekday.mon": "Пн",
  "weekday.tue": "Вт",
  "weekday.wed": "Ср",
  "weekday.thu": "Чт",
  "weekday.fri": "Пт",
  "weekday.sat": "Сб",
  "weekday.sun": "Нд",

  // Повні назви — для заголовка дня. Короткі лишаються для сітки.
  "weekdayFull.1": "Понеділок",
  "weekdayFull.2": "Вівторок",
  "weekdayFull.3": "Середа",
  "weekdayFull.4": "Четвер",
  "weekdayFull.5": "Пʼятниця",
  "weekdayFull.6": "Субота",
  "weekdayFull.7": "Неділя",

  "week.goals": "Цілі тижня",
  "week.nothing": "Нічого не заплановано",
  "week.entries": "{n, plural, one {# запис} few {# записи} many {# записів} other {# запису}}",
  "week.emptyTitle": "Перший тиждень",
  "week.emptyText": "Ціль тижня не належить жодному дню — її місце тут, над днями.",

  "month.grid": "Сітка місяця",
  "month.plan": "План місяця",
  "month.legend.plan": "Пункти плану",
  "month.legend.entry": "Є запис",
  "month.legend.important": "Важлива дата",
  // Уся клітинка читається одним реченням: форма позначок читачу екрана не видна.
  "month.cell": "{date}{total, plural, =0 {} one {, # пункт} few {, # пункти} many {, # пунктів} other {, # пункту}}{done, plural, =0 {} other {, зроблено #}}{entry, plural, =0 {} other {, є запис}}{important, plural, =0 {} other {, важлива дата}}",

  "db.starting": "Відкриваю сховище…",
  "db.parked": "Береста відкрита в іншій вкладці",
  // Напис мусить зʼєднати себе з кнопкою поруч. Найчастіший випадок —
  // людина ту другу вкладку вже закрила й не розуміє, про що їй кажуть.
  "db.parkedHint":
    "Щоденник відкривається в одному місці за раз — так влаштоване сховище. Записи цілі. Натисніть «Продовжити тут»: щоденник переїде сюди, а та вкладка покаже це саме повідомлення. Якщо ви її вже закрили — натискайте сміливо.",
  "db.takeOver": "Продовжити тут",
  "db.failed": "Сховище не відкрилося: {reason}. Записи зараз нікуди зберігати.",
  "db.failedPrivate": "Схоже, це приватна вкладка — у ній записам немає місця. Відкрийте Бересту у звичайній. ({reason})",

  "inbox.capture": "Записати, не вирішуючи куди",
  "time.todayAt": "сьогодні, {time}",
  "time.yesterdayAt": "учора, {time}",
  "inbox.placeholder": "Що спало на думку",
  "inbox.empty": "Сюди потрапляє те, що записали нашвидку, не вирішуючи куди. Розібрати можна будь-коли.",
  "inbox.toPlan": "У план",
  "inbox.discard": "Прибрати",

  "feed.empty": "Тут збираються щоденникові записи, від нових до старих. Перший можна написати просто зараз.",
  "feed.empty.entry": "запис без тексту",
  "feed.more": "Показати давніші",
  "feed.loading": "Готую стрічку…",



  "page.feed": "Стрічка",
  "page.notes": "Нотатки",
  "page.inbox": "Інбокс",
  "page.reminders": "Нагадування",
  "page.search": "Пошук",
  "page.people": "Люди",
  "page.groups": "Групи",
  "page.more": "Ще",
  "page.profile": "Профіль і візитка",
  "page.appearance": "Вигляд",
  "page.sync": "Синхронізація",
  "page.lock": "Замок застосунку",
  "page.encryption": "Шифрування",
  "page.export": "Вивантаження архіву",
  "page.about": "Про застосунок",
  "page.account": "Обліковий запис",
  "page.notify": "Сповіщення",
  "page.connections": "Підключення",
  "page.calendars": "Календарі",
  "page.tasks": "Google Tasks",
  "page.contacts": "Імпорт контактів",
  "page.backup": "Резервна копія",



  // ── Акаунт, ключ відновлення, замок ────────────────────────────────
  // Канва «Довіра» (design/canvases/beresta-trust). Тон тут важливіший, ніж деінде:
  // це єдине місце, де застосунок каже «ми не зможемо допомогти».
  "update.ready": "Є нова версія застосунку.",
  "update.apply": "Оновити",

  "settings.account": "Акаунт",

  // Показується, доки вантажиться сам розділ, тож мусить лежати тут, а не
  // в його власному каталозі: на цю мить того ще немає.
  "sync.loading": "Готую…",

  "unlock.title": "Введіть пароль",
  "unlock.passkey": "Відімкнути біометрією",
  "unlock.google": "Відімкнути через Google",
  "unlock.introGoogle": "Цей пристрій замкнено. Записи на місці — їх відмикає вхід Google або ключ відновлення.",
  "unlock.back": "Назад",
  "unlock.intro": "Цей пристрій замкнено. Записи на місці — їх треба відімкнути паролем.",
  "unlock.passphrase": "Пароль",
  "unlock.enter": "Відімкнути",
  "unlock.wrong": "Не той пароль.",
  "unlock.forgot": "Забули пароль?",
  "unlock.recovery": "Ключ відновлення",
  "unlock.recoveryHint": "Введіть їх через пробіл, у тому ж порядку.",
  "unlock.recoveryWrong": "Слова не приймаються. Перевірте порядок і написання.",
  // Показується лише після невдалого пароля, і лише в ньому. Причина
  // конкретна: 2026-08-28 змінився вивід майстер-ключа (комiт d963f24,
  // ADR-0018), а міграції для вже заведених акаунтів не було. Пароль у
  // таких людей правильний — не підходить ключ, який із нього виводиться.
  // Мовчати про це означало б лишати їх переконувати застосунок у тому,
  // що вони памʼятають власний пароль.
  "unlock.legacyHint":
    "Якщо акаунт заведено до 28 серпня 2026, пароль до нього більше не підходить: тоді змінився вивід ключа. Увійдіть двадцятьма чотирма словами й задайте пароль наново в налаштуваннях.",
  // Пароль підійшов, архів відкрито — впало те, що йде після. Окреме
  // повідомлення, бо порада тут протилежна: пароль перебирати не треба.
  // Воркер виводу ключа не відповів або впав. Не про пароль узагалі, тому
  // ні «спробуйте інший», ні підказки про старий акаунт тут немає.
  "unlock.derivation":
    "Не вдалося порахувати ключ на цьому пристрої. Закрийте зайві вкладки й спробуйте ще раз.",
  "unlock.opened": "Пароль підійшов, але завершити вхід не вдалося. Перезавантажте сторінку й спробуйте ще раз.",
  // Запису акаунта немає в сховищі. Це не пароль і не збій входу — це
  // порожнє сховище, і пропонувати тут «спробуйте інший пароль» безглуздо.
  "unlock.noAccount": "На цьому пристрої немає запису акаунта. Заведіть його наново або увійдіть поштою й паролем.",
  /*
   * Головне речення на цьому екрані, і воно окреме навмисно: збій виводу
   * ключа людина за замовчуванням читає як «пароль не той» і починає
   * перебирати паролі, яких не забувала. Сказати протилежне треба прямо,
   * а не натяком у довгому абзаці.
   */
  "unlock.notThePassword": "Пароль тут ні до чого.",
  "unlock.reload": "Перезавантажити",
  "unlock.reveal": "Показати",
  "unlock.hide": "Сховати",
  "unlock.byWords": "Увійти словами",
  "unlock.byPassphrase": "Увійти паролем",
} as const;
